export default [
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/Home.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Login.vue'),
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        component: () => import('@/views/NotFound.vue'),
    },
    {
        path: '/customers',
        name: 'customers',
        component: () => import('@/views/Customers.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/physical-users/edit/:id',
        name: 'editPhysicalUser',
        props: true,
        component: () => import('@/components/customer/PhysicalUserEdit.vue'),
        meta: { requiresAuth: true, title: 'Редактирование физ. лица' }
    },
    {
        path: '/physical-users/add',
        name: 'addPhysicalUser',
        component: () => import('@/components/customer/PhysicalUserEdit.vue'),
        meta: { requiresAuth: true, title: 'Добавление физ. лица' }
    },
    {
        path: '/companies/add',
        name: 'addCompany',
        component: () => import('@/components/company/CompanyEdit.vue'),
        meta: { title: 'Добавление компании', requiresAuth: true }
    },
    {
        path: '/companies/edit/:id',
        name: 'editCompany',
        component: () => import('@/components/company/CompanyEdit.vue'),
        props: true,
        meta: { title: 'Редактирование компании', requiresAuth: true }
    },
    {
        path: '/products',
        name: 'products',
        component: () => import('@/views/Products.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/edit-product/:id',
        name: 'editProduct',
        props: true,
        component: () => import('@/views/EditProduct.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/services',
        name: 'services',
        component: () => import('@/views/Services.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/add-service',
        name: 'addService',
        component: () => import('@/views/EditService.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/edit-service/:id',
        name: 'editService',
        props: true,
        component: () => import('@/views/EditService.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/add-product',
        name: 'addProduct',
        component: () => import('@/views/EditProduct.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/categories',
        name: 'categories',
        component: () => import('@/views/Categories.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/add-category',
        name: 'addCategory',
        component: () => import('@/views/EditCategory.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/edit-category/:id',
        name: 'editCategory',
        props: true,
        component: () => import('@/views/EditCategory.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/orders',
        name: 'orders',
        component: () => import('@/views/Orders.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/edit-order/:id',
        name: 'editOrder',
        props: true,
        component: () => import('@/views/EditOrder.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/add-order',
        name: 'addOrder',
        component: () => import('@/views/EditOrder.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/promotions',
        name: 'promotions',
        component: () => import('@/views/Promotions.vue'),
    },
    {
        path: '/add-promotion',
        name: 'addPromotion',
        component: () => import('@/views/EditPromotion.vue'),
    },
    {
        path: '/edit-promotion/:id',
        name: 'editPromotion',
        props: true,
        component: () => import('@/views/EditPromotion.vue'),
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('@/views/Profile.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/settings',
        name: 'settings',
        component: () => import('@/views/Settings.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/users',
        name: 'users',
        component: () => import('@/views/Users.vue'),
    },
    {
        path: '/edit-user/:id',
        name: 'editUser',
        props: true,
        component: () => import('@/views/EditUser.vue'),
    },
    {
        path: '/add-user',
        name: 'addUser',
        component: () => import('@/views/EditUser.vue'),
    },
    {
        path: '/delivery',
        name: 'delivery',
        component: () => import('@/views/Delivery.vue'),
    },
    {
        path: '/price-types',
        name: 'priceTypes',
        component: () => import('@/views/PriceTypes.vue'),
    },
    {
        path: '/price-types/add',
        name: 'addPriceType',
        component: () => import('@/components/pricetypes/Edit.vue'),
        meta: { requiresAuth: true, title: 'Добавление тарифа' }
    },
    {
        path: '/price-types/edit/:id',
        name: 'editPriceType',
        props: true,
        component: () => import('@/components/pricetypes/Edit.vue'),
        meta: { requiresAuth: true, title: 'Редактирование тарифа' }
    },
    {
        path: '/tariff-requests',
        name: 'tariffRequests',
        component: () => import('@/views/TariffRequests.vue'),
        meta: { requiresAuth: true, title: 'Заявки на смену тарифа' }
    },
]